export default "__VITE_ASSET__BlACjy3K__"